import React from 'react'

function CoverLetterWrite() {
  return (
    <svg
      xmlns="http://www.w3.org/2000/svg"
      width="16"
      height="16"
      viewBox="0 0 16 16"
      aria-label="자소서작성"
    >
      <desc>자소서작성</desc>
      <g data-name="그룹 1140">
        <g fill="#fff" stroke="#fff" data-name="사각형 1518">
          <path stroke="none" d="M9.264 12.916h6.457v1.211H9.264z"></path>
          <path fill="none" d="M9.764 13.416h5.457v.211H9.764z"></path>
        </g>
        <g
          fill="none"
          strokeLinecap="round"
          strokeLinejoin="round"
          data-name="패스 536"
        >
          <path d="M11.767 0l-9.65 9.65v4.232h4.23L16 4.234z"></path>
          <path
            fill="#fff"
            d="M11.769 2.124l-8.153 8.148v2.11h2.11l8.152-8.149-2.109-2.11m0-2.12L16 4.232l-9.653 9.649-4.231.001V9.651L11.77.002z"
          ></path>
        </g>
        <g fill="#fff" stroke="#fff" data-name="사각형 1519">
          <path
            stroke="none"
            d="M9.472 2.769l3.424 3.423-.857.857-3.423-3.424z"
          ></path>
          <path
            fill="none"
            d="M9.472 3.476l2.717 2.716-.15.15-2.716-2.717z"
          ></path>
        </g>
      </g>
    </svg>
  )
}

export default CoverLetterWrite
